import classNames from 'classnames';

export default function Spacer(props) {
    return (<div className={classNames("hidden md:block", props.className)}/>);
};